import bikesImage from "./images/bikes.webp"

export const bikesData = {
    id: "bikes",
    title: `Wypożyczalnia rowerów "Velo Czorsztyn"`,
    description: ` Zapraszamy do skorzystania z naszej wypożyczalni rowerów „Velo Czorsztyn”, zlokalizowanej bezpośrednio przy naszej przystani gondoli nad Jeziorem Czorsztyńskim. To idealne miejsce dla wszystkich miłośników aktywnego wypoczynku, którzy chcą połączyć przyjemność zwiedzania z komfortem i swobodą jazdy na rowerze w jednej z najpiękniejszych okolic Małopolski.` ,
    afterLink: "lub telefonicznie +48 509 923 730",
    imageSrc: bikesImage,
    imageAlt: "photo of bikes for rent in Czorsztynianka bike rental",
};